import { useEffect } from "react";

const useFadeInOnScroll = () => {
  useEffect(() => {
    const fadeElements = document.querySelectorAll(".fade-element");
    const fadeElementsH = document.querySelectorAll(".fade-element-h");

    // Set a random transition duration for each element
    [...fadeElements, ...fadeElementsH].forEach((el) => {
      el.style.setProperty("--random-speed", Math.random().toFixed(2));
    });

    const handleFadeInOnScroll = () => {
      fadeElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const elementTrigger = rect.top + rect.height * 0.3; // 30% of element's height
        const windowHeight = window.innerHeight;

        // Add fade-in if 30% of the element is in view
        if (elementTrigger < windowHeight) {
          el.classList.add("fade-in");
        } else {
          el.classList.remove("fade-in"); // Reset when scrolling up
        }
      });
      fadeElementsH.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const elementTrigger = rect.left + rect.width * 0.4; // 30% of width
        const windowWidth = window.innerWidth;

        if (elementTrigger < windowWidth) {
          el.classList.add("fade-in-h");
        } else {
          el.classList.remove("fade-in-h");
        }
      });
    };

    // Optimize with requestAnimationFrame
    let scrollTimeout;
    const onScroll = () => {
      if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
      scrollTimeout = requestAnimationFrame(handleFadeInOnScroll);
    };

    window.addEventListener("scroll", onScroll);
    handleFadeInOnScroll(); // Initial trigger

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

};

export default useFadeInOnScroll;
